module.exports = require("./qu-EC");